import { render } from "./KioskActionSectionSkeleton.vue?vue&type=template&id=cc64a504"
const script = {}

import "./KioskActionSectionSkeleton.vue?vue&type=style&index=0&id=cc64a504&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__